var Acre = "Acre";
var Alagoas = "Alagoas";
var Amazonas = "Amazonas";
var Bahia = "Bahia";
var Pernambuco = "Pernambuco";
var Roraima = "Roraima";
var Sergipe = "Sergipe";
var Tocantins = "Tocantins";
var PTStates = {
	Acre: Acre,
	Alagoas: Alagoas,
	"Amapá": "Amapá",
	Amazonas: Amazonas,
	Bahia: Bahia,
	"Ceará": "Ceará",
	"Federal District": "Federal District",
	"Espírito Santo": "Espírito Santo",
	"Goiás": "Goiás",
	"Maranhão": "Maranhão",
	"Mato Grosso": "Mato Grosso",
	"Mato Grosso do Sul": "Mato Grosso do Sul",
	"Minas Gerais": "Minas Gerais",
	"Pará": "Pará",
	"Paraíba": "Paraíba",
	"Paraná": "Paraná",
	Pernambuco: Pernambuco,
	"Piauí": "Piauí",
	"Rio de Janeiro": "Rio de Janeiro",
	"Rio Grande do Norte": "Rio Grande do Norte",
	"Rio Grande do Sul": "Rio Grande do Sul",
	"Rondônia": "Rondônia",
	Roraima: Roraima,
	"Santa Catarina": "Santa Catarina",
	"São Paulo": "São Paulo",
	Sergipe: Sergipe,
	Tocantins: Tocantins
};

export { Acre, Alagoas, Amazonas, Bahia, Pernambuco, Roraima, Sergipe, Tocantins, PTStates as default };
